import { render, staticRenderFns } from "./CheckoutAutomation.vue?vue&type=template&id=53f2ad0c&scoped=true"
import script from "./CheckoutAutomation.vue?vue&type=script&lang=js"
export * from "./CheckoutAutomation.vue?vue&type=script&lang=js"
import style0 from "./CheckoutAutomation.vue?vue&type=style&index=0&id=53f2ad0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f2ad0c",
  null
  
)

export default component.exports